export default __webpack_public_path__ + "static/media/warning--double-reverse-curve-right--g2.220ae800.png";